'use client';

import {useTageaRouter} from '@web-libs/core/routing/application/use-tagea-router.concern';
import {StyledLink} from '@web-libs/ui/ui-components/typo/styled-link';

export const Footer = () => {

    const router = useTageaRouter();

    const footerStyle = {
        width: '100%',
        height: '60px',
        lineHeight: '60px',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        justifyContent: 'center',
        gap: '50px',
        zIndex: 2,
    };

    return (
        <>
            <div style={footerStyle}>
                <StyledLink
                    href={router.getLink('impressum')}
                    text={'Impressum'}>
                </StyledLink>
                <StyledLink
                    text={'Datenschutz'}
                    href={router.getLink('datenschutz')}
                >
                </StyledLink>
            </div>
        </>
    );
};
